import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { MacroRendererPageLoader } from '@confluence/mobile-app-macro-renderer';

import { ContentExtensionsProvider } from '../../ContentExtensionsProvider/index.ts';

export const MobileMacroRendererRoute: {
	({ params: { contentId } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ name, params: { contentId } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
				attributes: {
					contentId: string;
				};
			};
			pageState: {
				routeName: string;
				contentId: string;
			};
		};
		MainLayout: boolean;
	};
} = ({ params: { contentId } }: RouteMatch): React.JSX.Element => {
	return (
		<MacroRendererPageLoader
			contentId={contentId}
			ContentExtensionsProvider={ContentExtensionsProvider}
		/>
	);
};

MobileMacroRendererRoute.NAVIGATION_PARAMS = ({
	name,
	params: { contentId },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
			attributes: {
				contentId: string;
			};
		};
		pageState: {
			routeName: string;
			contentId: string;
		};
	};
	MainLayout: boolean;
} => ({
	Screen: {
		screenEvent: {
			name: 'mobileMacroRendererScreen',
			id: contentId,
			attributes: {
				contentId,
			},
		},
		pageState: {
			routeName: name,
			contentId,
		},
	},
	MainLayout: false, // No navigation layout needed for mobile app view
});
